(function () {
  function initMobileSubmenus() {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    headerDrawer.querySelectorAll('.menu-drawer__navigation details:not(.menu-drawer__section-group)').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary || summary.dataset.mobileSubmenuBound === 'true') return;

      summary.dataset.mobileSubmenuBound = 'true';
      summary.addEventListener('click', () => {
        requestAnimationFrame(() => {
          if (!details.hasAttribute('open')) return;

          details.classList.add('menu-opening');
          const parentMenu = details.closest('.has-submenu');
          parentMenu?.classList.add('submenu-open');
          summary.setAttribute('aria-expanded', 'true');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initMobileSubmenus);
  document.addEventListener('shopify:section:load', initMobileSubmenus);
})();
